import React from 'react'
import { render } from 'react-snapshot'
import ReactGA from 'react-ga'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize('UA-109529177-1')
    ReactGA.pageview(window.location.pathname + window.location.search)
}

render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js